import { StyledButton, ButtonContent, Arrow, ArrowWrapper } from './button-styles'

type ButtonProps = {
  disable?: boolean
  altText?: string
  buttonIcon?: JSX.Element
  buttonText: string
  onClick: () => void
  isRightArrow?: boolean
  isCircle?: boolean
  isPrimary?: boolean
  maxContent?: boolean
}

const Button = ({
  disable = false,
  maxContent = false,
  altText,
  buttonIcon,
  buttonText,
  isRightArrow = true,
  isCircle = true,
  isPrimary = true,
  onClick
}: ButtonProps) => (
  <StyledButton
    isCircle={isCircle}
    disabled={disable}
    onClick={onClick}
    isPrimary={isPrimary}
    title={`${altText || buttonText} button`}
    data-testid={`${buttonText.replace(' ', '-').toLowerCase()}-button`}
    maxContent={maxContent}
  >
    <ButtonContent>
      {buttonIcon && buttonIcon}
      {buttonText}
    </ButtonContent>
    {isRightArrow && isCircle && (
      <ArrowWrapper
        data-testid="arrow-circle"
        isPrimary={isPrimary}
        maxContent={maxContent}
        disabled={disable}
      >
        <Arrow
          data-testid="right-arrow"
          isPrimary={isPrimary}
          isCircle={isCircle}
          disabled={disable}
        >
          &rarr;
        </Arrow>
      </ArrowWrapper>
    )}
    {isRightArrow && !isCircle && (
      <Arrow data-testid="right-arrow" isPrimary={isPrimary} isCircle={isCircle}>
        &rarr;
      </Arrow>
    )}
  </StyledButton>
)

export default Button
